import { StytchUIClient } from "@stytch/vanilla-js";

import { environment } from "@config";

const stytch = new StytchUIClient(environment.stytch.publicToken);

const loginWithGoogle = () => {
  stytch.oauth.google.start({
    login_redirect_url: environment.stytch.loginRedirect,
    signup_redirect_url: environment.stytch.signUpRedirect,
  });
};

const authenticate = async (token: string) => {
  return stytch.oauth.authenticate(token, {
    session_duration_minutes: 60,
  });
};

export const Authentication = { authenticate, loginWithGoogle };
